<template>
  <div>
    <p class="input-text-size">This tax record has a Mobile Home.
       If you are issuing a decal, please enter the decal number below.</p>
  <v-data-table :headers="headers" :items="editeditems"
  class="hide-footer-select elevation-1 input-text-size"
  hide-default-footer>
    <template v-slot:item="{ item }">
      <tr>
        <td>
          <v-text-field v-model="item.taxYear" dense class="input-text-size" readonly tabindex="-1" />
        </td>
        <td>
          <v-text-field v-model="item.taxId" dense class="input-text-size" readonly tabindex="-1" />
        </td>
        <td>
          <v-text-field v-model="item.mhDecal" dense class="input-text-size" />
        </td>
      </tr>
    </template>
  </v-data-table>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { CommonDecalDialogHeaders } from '../paymentutils/PaymentTransactionTableHeaders';

export default {
  name: 'CommonDecalDialog',
  data() {
    return {
      headers: CommonDecalDialogHeaders,
      baseCrudKey: 'ComhDecalmmonDecalDialogCrudKey',
    };
  },
  computed: {
    ...mapGetters('base/crud', ['items']),
    editeditems: {
      get() {
        return this.items(this.baseCrudKey);
      },
      set(value) {
        this.setItems([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setIsVisible', 'setItem']),
  },
};
</script>
